import { Stack, router } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { Button, IconBottomNavigationReorder, Text, tokens } from '@fhs/ui';
import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

import { getScreenTitleHeader } from '../get-screen-title-header';

const recentOrdersHeader = getScreenTitleHeader({
  backStyle: 'back',
  cannotGoBackHref: '/account',
  showDivider: true,
});

export function UnauthenticatedRecentOrders() {
  const { setOriginLocation } = useAuthContext();

  return (
    <View style={styles.screen}>
      <Stack.Screen options={{ title: 'Recent Orders', header: recentOrdersHeader }} />
      <View style={styles.content}>
        <View style={styles.card}>
          <IconBottomNavigationReorder
            size={80}
            color={tokens.colors.$blackOpacity10}
            aria-hidden
          />
          <View style={styles.copy}>
            <Text weight="semibold" style={styles.title}>
              Recent Orders Will Appear Here
            </Text>
            <Text style={styles.description}>
              Log in or create an account to view past orders and quickly reorder your favorites.
            </Text>
          </View>
          <Button
            size="lg"
            accessibilityRole="button"
            accessibilityLabel="Log In or Sign Up"
            onPress={() => {
              setOriginLocation(routes.orders);
              router.push(routes.signInV2);
            }}
            style={styles.loginButton}
          >
            <Button.Text>Log In / Sign Up</Button.Text>
          </Button>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: tokens.colors.$white,
  },
  content: {
    paddingTop: 24,
    paddingHorizontal: 16,
  },
  card: {
    alignItems: 'center',
    gap: 16,
    width: '100%',
    paddingTop: 8,
    paddingBottom: 16,
    paddingHorizontal: 16,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
    borderRadius: 8,
    backgroundColor: tokens.colors.$white,
  },
  copy: {
    alignSelf: 'stretch',
    gap: 8,
  },
  title: {
    fontSize: 18,
    lineHeight: 25,
    textAlign: 'center',
  },
  description: {
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'center',
  },
  loginButton: {
    backgroundColor: tokens.colors.$bottomNavigationActive,
    borderColor: tokens.colors.$bottomNavigationActive,
  },
});
